<template>
  <footer>
    <div class="footer-wrapper">
      <div>
        <footer-SNS></footer-SNS>
        <p class="footer-text">TOSHIHIRO YUASA | info@ToshihiroYuasa.jp</p>
      </div>
      <footer-scroll></footer-scroll>
    </div>
  </footer>
</template>

<script>
import FooterSNS from '@/components/FooterSNS.vue';
import FooterScroll from '@/components/FooterScroll.vue';

export default {
  components: {
    FooterSNS,
    FooterScroll
  }
}
</script>

<style lang="scss" scoped>
footer {
  display: flex;
  justify-content: center;
  margin: 50px auto 0;
}

.footer-wrapper {
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 97vw;
}

.footer-text {
  font-size: 5px;
}
</style>